import { dbPromise } from "./db"

// Caches the worker's (and their teams') saved attendances + performances for
// the offline window (today + the next few days). Mirrors schedule_entries_cache:
// schedule entries are the *plan*, these are what was actually *saved*.
//
// Shape stored under ATTENDANCES_CACHE_KEY:
//   byDate[dateIso][workerId] = {
//     id, worker_id, date, showed_up_at, left_at, weather_id, is_holiday,
//     vacation_pattern_id, attendance_rule_id, performances: [ ...rows ]
//   }

const ATTENDANCES_CACHE_KEY = "weekly_attendances"

export async function saveAttendancesCache(byDate) {
  if (!byDate) return
  const db = await dbPromise
  const pruned = pruneOldDates(byDate)
  await db.put("attendances_cache", {
    key: ATTENDANCES_CACHE_KEY,
    byDate: pruned,
    savedAt: new Date().toISOString()
  })
}

export async function getAttendancesCache() {
  const db = await dbPromise
  try {
    return (await db.get("attendances_cache", ATTENDANCES_CACHE_KEY)) || null
  } catch {
    return null
  }
}

export async function getAttendancesForDate(dateIso) {
  const record = await getAttendancesCache()
  return record?.byDate?.[dateIso] || null
}

export async function getAttendanceForWorker(dateIso, workerId) {
  const byWorker = await getAttendancesForDate(dateIso)
  if (!byWorker) return null
  return byWorker[String(workerId)] || null
}

export async function getPerformancesForWorker(dateIso, workerId) {
  const attendance = await getAttendanceForWorker(dateIso, workerId)
  return attendance?.performances || []
}

function pruneOldDates(byDate) {
  const today = todayIso()
  return Object.fromEntries(
    Object.entries(byDate).filter(([dateIso]) => dateIso >= today)
  )
}

function todayIso() {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, "0")
  const day = String(d.getDate()).padStart(2, "0")
  return `${y}-${m}-${day}`
}
